import { Freebets } from '../types';
import { ReduxState } from 'app/redux/types';

import { selectFreeBets } from './state';

// ---

export const selectFreeBetsData =  (state: ReduxState): Freebets['data'] => (
  selectFreeBets(state).data
);
export const selectFreeBetsLoading = (state: ReduxState): Freebets['loading'] => (
  selectFreeBets(state).loading
);
export const selectFreeBetsRequested = (state: ReduxState): Freebets['requested'] => (
  selectFreeBets(state).requested
);
export const selectFreeBetsError = (state: ReduxState): Freebets['error'] => (
  selectFreeBets(state).error
);
